import { Navigate, Route, Routes } from 'react-router-dom';
import { AppRoutes, UserType } from '../../utils/props';
import Login from '../../pages/Login/Login'
import Register from '../../pages/Register/Register';
import PersonalInformation from '../../pages/PersonalInformation/PersonalInformation';
import Documents from '../../pages/Documents/Documents';
import Users from '../../pages/Users/Users';
import UserProfile from '../../pages/UserProfile/UserProfile';
import UserDocuments from '../../pages/UserDocuments/UserDocuments';
import ForgotPassword from '../../pages/ForgotPassword/ForgotPassword';
import ChangePassword from '../../pages/ChangePassword/ChangePassword';
import FileApproval from '../../pages/FileApproval/FileApproval';
import FileEdit from '../../pages/FileEdit/FileEdit';
import Header from '../Header';
import Footer from '../Footer';

export default function Router() {
  function RedirectHome() {
    const token = localStorage.getItem('token');
    const type = localStorage.getItem('type');
    if (!token) {
      return <Navigate to={AppRoutes.Login} replace />
    }
    if (type === UserType.Admin.toString()) {
      return <Navigate to={AppRoutes.Users} replace />
    }
    else if (type === UserType.Regular.toString()) {
      return <Navigate to={AppRoutes.PersonalInformation} replace />
    }
    return <Navigate to={AppRoutes.Login} replace />
  }

  return (
    <>
      <Header />
      <Routes>
        <Route path={AppRoutes.Login} element={<Login />} />
        <Route path={AppRoutes.Register} element={<Register />} />
        <Route path={AppRoutes.PersonalInformation} element={<PersonalInformation />} />
        <Route path={AppRoutes.Documents} element={<Documents />} />
        <Route path={AppRoutes.Users} element={<Users />} />
        <Route path={AppRoutes.UserInformation} element={<UserProfile />} />
        <Route path={AppRoutes.UserDocuments} element={<UserDocuments />} />
        <Route path={AppRoutes.ForgotPassword} element={<ForgotPassword />} />
        <Route path={AppRoutes.ChangePassword} element={<ChangePassword />} />
        <Route path={AppRoutes.FileApproval} element={<FileApproval />} />
        <Route path={AppRoutes.FileEdit} element={<FileEdit />} />
        <Route path={AppRoutes.Index} element={<RedirectHome />} />
      </Routes>
      <Footer />
    </>
  )
}